<template>
    <div class="person" v-if="person">
        <div class="avatar" v-if="person.avatar">
            <Image :image="person.avatar" :width="80" :height="80" :mobileHeight="120" :mobileWidth="120" imageClass="cover" />
        </div>
        <div class="info">
            <div class="name helvetica title6">{{ person.name }}</div>
            <div class="role">{{ person.role }}</div>
        </div>
    </div>
</template>

<script lang="ts" setup>
defineProps<{ person: any }>()
</script>

<style lang="scss" scoped>
.person {
    display: grid;
    grid-template-columns: 80px 1fr;
    gap: var(--size-gutter-default);

    .avatar {
        position: relative;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
    }

    .info {
        display: flex;
        flex-direction: column;

        .name {
            font-weight: bold;
        }

        .role {
            text-wrap: balance;
        }
    }
}

@media screen and (max-width: 1200px) {
    .person {
        grid-template-columns: 60px 1fr;

        .avatar {
            width: 60px;
            height: 60px;
        }
    }
}
</style>